import api from "@/utils/api";

/**
 * 字典相关接口
 */

/**
 * 获取作品字数列表
 * @returns {Promise}
 */
export function getWords() {
  return api.get("/dictionary/wordCount");
}

/**
 * 获取作品类型列表
 * @returns {Promise}
 */
export function getWorkType() {
  return api.get("/dictionary/workType");
}

/**
 * 获取作品分类列表
 * @returns {Promise}
 */
export function getWorkCategory() {
  return api.get("/dictionary/workCategory");
}

/**
 * 获取读者分类列表
 * @returns {Promise}
 */
export function getReaderCategory() {
  return api.get("/dictionary/readerCategory");
}

/**
 * 获取读者情绪列表
 * @returns {Promise}
 */
export function getReaderEmotion() {
  return api.get("/dictionary/readerEmotion");
}

/**
 * 获取作品风格列表
 * @returns {Promise}
 */
export function getWorkStyle() {
  return api.get("/dictionary/workStyle");
}

/**
 * 获取平台列表
 * @returns {Promise}
 */
export function getPlatform() {
  return api.get("/dictionary/platform");
}

/**
 * 根据字段获取平台匹配列表
 * @param {Object} data - 匹配参数
 * @param {string} data.word_count_id - 作品字数ID
 * @param {string} data.work_category_ids - 作品分类ID
 * @param {string} data.reader_category_ids - 读者分类ID
 * @param {string} data.reader_emotion_ids - 读者情绪ID
 * @param {string} data.work_style_ids - 作品风格ID
 * @param {string} data.work_type_ids - 作品类型ID
 * @returns {Promise}
 */
export function getPlatformMatch(data) {
  return api.post("/dictionary/platformMatch", data);
}

/**
 * 收藏列表
 * @param {Object} params - 查询参数
 * @param {number} params.limit - 每页数量
 * @param {number} params.page - 分页页码
 * @returns {Promise}
 */
export function getFavoriteEditorList(params) {
  return api.get("/submission/favoriteEditorList", { params });
}

/**
 * 新增收藏(编辑)
 * @param {Object} data - 匹配参数
 * @param {string|number} data.platform_email_id - 平台邮箱ID
 * @returns {Promise}
 */
export function addFavoriteEditor(data) {
  return api.post("/submission/addFavoriteEditor", data);
}

/**
 * 删除收藏
 * @param {Object} data - 匹配参数
 * @param {string|number} data.id - 收藏记录ID
 * @returns {Promise}
 */
export function deleteFavoriteEditor(data) {
  return api.post("/submission/deleteFavoriteEditor", data);
}

/**
 * 通讯录新增
 * @param {Object} data - 匹配参数
 * @param {string|number} data.name - 名字
 * @param {string|number} data.email - 邮箱
 * @returns {Promise}
 */
export function addAddressBook(data) {
  return api.post("/submission/addAddressBook", data);
}

/**
 * 通讯录编辑
 * @param {Object} data - 匹配参数
 * @param {string|number} data.id - （通讯录ID）
 * @param {string|number} data.name - 名字
 * @param {string|number} data.email - 邮箱
 * @returns {Promise}
 */
export function editAddressBook(data) {
  return api.post("/submission/editAddressBook", data);
}

/**
 * 通讯录删除
 * @param {Object} data - 匹配参数
 * @param {string|number} data.id - （通讯录ID）
 * @returns {Promise}
 */
export function deleteAddressBook(data) {
  return api.post("/submission/deleteAddressBook", data);
}

/**
 * 通讯录列表
 * @param {Object} data - 查询参数
 * @param {number} params.limit - 每页数量
 * @param {number} params.page - 分页页码
 * @returns {Promise}
 */
export function getAddressBookList(data) {
  return api.post("/submission/addressBookList", data);
}
